import { envPublic, warnIfMissingCloudFunctionUrlInDev } from '@/libs/config';
import { getAuthToken, getAuthUser } from '@/libs/firebase/auth';
import { applyInterceptors, createApiClient } from '../api-client';
import { createApiFactory } from '../api-factory';
import { createFirebaseCloudFunctionsAbortInterceptor } from '../firebase-cloud-functions-scope';
import {
  createAuthInterceptor,
  createCloudFunctionsBaseUrlInterceptor,
  createDebugLogRequestInterceptor,
  createDebugLogResponseInterceptor,
  createErrorInterceptor,
  createNetworkCheckInterceptor,
  createNetworkRetryInterceptor,
} from '../interceptors';
import type { TokenProvider } from '../types';

const firebaseTokenProvider: TokenProvider = {
  getAccessToken: async () => {
    const user = getAuthUser();
    if (!user?.emailVerified) {
      return null;
    }
    return await getAuthToken();
  },
  getRefreshToken: async () => null,
  setTokens: async () => {},
  clearTokens: async () => {},
};

warnIfMissingCloudFunctionUrlInDev();

// `baseURL` here is just the dev default; the request interceptor below
// overrides it per-request based on the selected Firebase env.
const firebaseClient = createApiClient({
  baseURL: envPublic.firebaseCloudFunctionUrl,
});

applyInterceptors(
  firebaseClient,
  [
    createDebugLogRequestInterceptor(),
    createCloudFunctionsBaseUrlInterceptor(),
    createFirebaseCloudFunctionsAbortInterceptor(),
    createAuthInterceptor(firebaseTokenProvider),
    createNetworkCheckInterceptor(),
  ],
  [
    createDebugLogResponseInterceptor(),
    createNetworkRetryInterceptor(firebaseClient),
    createErrorInterceptor(),
  ],
);

export const firebaseCloudFunctionService = createApiFactory(firebaseClient);
